import { FC } from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { StanInput } from '@/components';
import type { AutomationFormData } from '../../validations/automationForm';

interface CommentReplyFieldProps {
    control: Control<AutomationFormData>;
    error?: FieldError;
}

const MAX_CHARS_PER_REPLY = 100;
const MAX_REPLIES = 3;

export const CommentReplyField: FC<CommentReplyFieldProps> = ({ control, error }) => {
    return (
        <Controller
            name='comment_choices'
            control={control}
            render={({ field }) => {
                const handleInputChange = (index: number, value: string) => {
                    const newChoices = [...field.value];
                    newChoices[index] = value;
                    field.onChange(newChoices);
                };

                return (
                    <div className='space-y-2'>
                        <label className='text-label-xs-bold md:text-label-sm-bold'>Replies</label>
                        <p className='text-label-xs-regular text-gray md:text-body-sm'>
                            Customize your automatic comment replies
                        </p>

                        <div className='space-y-2'>
                            {Array.from({ length: MAX_REPLIES }).map((_, index) => (
                                <StanInput
                                    key={`comment-choice-${index}`}
                                    id={`comment-choice-${index}`}
                                    name={`comment-choice-${index}`}
                                    value={field.value[index] || ''}
                                    onChange={e => handleInputChange(index, e.target.value)}
                                    maxLength={MAX_CHARS_PER_REPLY}
                                    placeholder='Choose a reply'
                                    error={!!error}
                                />
                            ))}
                        </div>

                        {error && <p className='text-caption-1-regular text-negative'>{error.message}</p>}
                    </div>
                );
            }}
        />
    );
};
